import React, { useEffect, useState, useRef } from "react";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from "../apiConfig";

const LossBonusList = () => {
  const [data, setData] = useState([]);
  const [limit] = useState(10);
  const [pageCount, setPageCount] = useState(1);

  const [summary, setSummary] = useState({
    totalRebateGiven: 0,
    totalBetAmount: 0,
    totalUser: 0
  });

  const [range, setRange] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const [username, setUsername] = useState("");

  const currentPage = useRef(1);

  useEffect(() => {
    currentPage.current = 1;
    fetchData();
  }, [range, sortBy, sortOrder]);

  const fetchData = () => {
    const params = new URLSearchParams({
      page: currentPage.current,
      limit,
      range,
      sortBy,
      sortOrder,
      ...(username && { username }),
      ...(range === "custom" && startDate && { startDate }),
      ...(range === "custom" && endDate && { endDate })
    });

    fetch(`${apiConfig.baseURL}/api/admin/LossBonusCommissionReport?${params}`)
      .then(res => res.json())
      .then(data => {
        setData(data.result);
        setPageCount(data.pageCount);
        setSummary({
          totalRebateGiven: data.totalRebateGiven,
          totalBetAmount: data.totalBetAmount,
          totalUser: data.totalUser
        });
      });
  };

  const handlePageClick = (e) => {
    currentPage.current = e.selected + 1;
    fetchData();
  };

  const handleSearch = () => {
    currentPage.current = 1;
    fetchData();
  };

  const handleReset = () => {
    setRange("all");
    setStartDate("");
    setEndDate("");
    setUsername("");
    setSortBy("createdAt");
    setSortOrder("desc");
    currentPage.current = 1;
    setTimeout(fetchData, 0);
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  const MyPaginate = styled(ReactPaginate)`
    display:flex;
    justify-content:center;
    list-style:none;
    li a{
      padding:6px 12px;
      border:1px solid #ddd;
      margin:2px;
      cursor:pointer;
    }
    li.active a{
      background:#007bff;
      color:#fff;
    }
  `;

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">

          {/* SUMMARY */}
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="card bg-primary text-white">
                <div className="card-body">
                  <h6>Total Users</h6>
                  <h3>{summary.totalUser}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card bg-warning text-white">
                <div className="card-body">
                  <h6>Total Bet Amount</h6>
                  <h3>৳{summary.totalBetAmount?.toLocaleString()}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card bg-success text-white">
                <div className="card-body">
                  <h6>Total Loss Bonus</h6>
                  <h3>৳{summary.totalRebateGiven?.toLocaleString()}</h3>
                </div>
              </div>
            </div>
          </div>

          <div className="card">

            <div className="card-header">
              <h4>Loss Bonus List</h4>
                       <a target="_blank" href="https://api.betwinzone.net/api/admin/LossBonusDistribute" ariaExpanded="false" >
                  <button type="button" className="btn btn-success">
                   Loss Bonus Distribute
                  </button>
                </a>
            </div>

            <div className="card-body">

              {/* FILTER BAR */}

              <div className="row mb-3">

                {/* DATE RANGE BUTTONS */}
                <div className="col-md-5">
                  <label>Date Range</label>
                  <div className="btn-group">
                    {["all","daily","weekly","monthly","custom"].map(r=>(
                      <button
                        key={r}
                        className={`btn btn-sm ${range===r ? "btn-primary":"btn-outline-primary"}`}
                        onClick={()=>setRange(r)}
                      >
                        {r}
                      </button>
                    ))}
                  </div>
                </div>

                {/* CUSTOM DATE */}
                {range==="custom" && (
                  <div className="col-md-4">
                    <label>Custom Date</label>
                    <div className="d-flex">
                      <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={e=>setStartDate(e.target.value)}
                      />

                      <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={e=>setEndDate(e.target.value)}
                      />
                    </div>
                  </div>
                )}

                {/* USER SEARCH */}
                <div className="col-md-3">
                  <label>Search Username</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="username..."
                      value={username}
                      onChange={(e)=>setUsername(e.target.value)}
                      onKeyDown={(e)=>e.key==="Enter" && handleSearch()}
                    />

                    <div className="input-group-append">
                      <button className="btn btn-primary" onClick={handleSearch}>
                        Search
                      </button>
                    </div>
                  </div>
                </div>

                <div className="col-md-2 mt-3">
                  <button className="btn btn-danger" onClick={handleReset}>
                    Reset
                  </button>
                </div>

              </div>

              {/* TABLE */}

              <div className="table-responsive">
                <table className="table table-bordered">

                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Username</th>
                      <th>Total Bet</th>
                      <th>Loss Bonus</th>
                      <th>Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data.length===0 ? (
                      <tr>
                        <td colSpan="5" className="text-center">No Data</td>
                      </tr>
                    ) : (
                      data.map((row,i)=>(
                        <tr key={row._id}>
                          <td>{(currentPage.current-1)*limit+i+1}</td>
                          <td>{row.username}</td>
                          <td>৳{row.totalAmount}</td>
                          <td>৳{row.amount}</td>
                          <td>{formatDate(row.createdAt)}</td>
                        </tr>
                      ))
                    )}
                  </tbody>

                </table>

                <MyPaginate
                  breakLabel="..."
                  nextLabel="Next"
                  previousLabel="Prev"
                  pageCount={pageCount}
                  onPageChange={handlePageClick}
                  forcePage={currentPage.current-1}
                />

              </div>

            </div>

          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default LossBonusList;